import React from 'react';
import { ArrowLong } from '../../../../assets/img/svg/icons';
import Events from '../../../Components/event';
import { EventInterface } from '../../../Services/types';

interface ListInterface {
    events: EventInterface[]
}

const EventosSection: React.FC<ListInterface> = ({events}: ListInterface) => {
    return (
        <section className='pt-8 pb-10 relative'>
            <div className="max-w-screen-lg mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <h3 className="text-2xl font-semibold text-balance text-center md:text-left">
                        Confira nossa agenda de eventos
                    </h3>

                    <a href="/eventos-realizados" title="Ver eventos anteriores" className={`group rounded-full text-center gap-3 inline-flex justify-center items-center p-4 uppercase text-xs font-semibold max-w-72 transition-all duration-200 w-full border-2 border-main-pink text-main-pink hover:bg-main-pink hover:text-white`}>
                        Ver eventos anteriores
                        <ArrowLong className='fill-main-pink transition-all duration-200 group-hover:fill-white' />
                    </a>
                </div>

                <div className="mt-8 grid md:grid-cols-2 gap-8">
                    {events?.splice(0, 2).map((event) => (
                        <Events key={event.id} slug={event.slug} local={event.local} title={event.titulo} type={event.tipo} date={event.data} thumbnail={event.thumbnail} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default EventosSection;